import { NavLink } from "./types";

const asset = (path: string) => `${import.meta.env.BASE_URL}assets/${path}`;

export const CTA_URL = "https://tally.so/r/BzXJo1";
export const DOSSIER_URL = "https://tally.so/r/D4xb4q";

export const HERO_VARIANT: "A" | "B" = "B";

export const NAV_LINKS: NavLink[] = [
  { id: "que-es", label: "Qué es AsiViajo", href: "#que-es" },
  { id: "para-quien", label: "Para quién", href: "#para-quien" },
  { id: "diferente", label: "Diferencial", href: "#diferente" },
  { id: "como-funciona", label: "Proceso", href: "#como-funciona" },
];

export const LANDING_COPY = {
  hero: {
    badge: "En mis 15",
    headline: "Más que un viaje, una experiencia.",
    subheadline:
      "Una edición anual para quinceañeras que convierte Europa en un antes y un después: más mundo, mejor criterio y recuerdos que sí dejan huella.",
    shortLine: "Grupo reducido. Selección previa. Una edición al año.",
    primaryCta: "Solicitar Preinscripción",
    secondaryCta: "Recibir Presentación para Padres",
  },
  whatIs: {
    title: "Qué es AsiViajo",
    paragraphs: [
      "AsiViajo no es un itinerario para ver ciudades.",
      "Es una experiencia diseñada para que tu hija regrese con más mundo: una mirada distinta, mayor seguridad personal y mejores hábitos de convivencia.",
      "Trabajamos con un grupo reducido para cuidar el ritmo, la convivencia y la calidad del acompañamiento. Cada edición se construye con un estándar claro: orden, respeto, puntualidad y experiencias culturales con intención.",
    ],
  },
  forWho: {
    title: "Para quién es",
    intro:
      "AsiViajo es para familias en Panamá que buscan una experiencia en Europa que:",
    bullets: [
      "Sea organizada y bien acompañada, sin improvisación.",
      "Cuide la convivencia y el respeto como prioridad.",
      "Fomente autonomía responsable (sin dejar de ser divertido).",
      "Valore cultura, buen gusto y criterio.",
      "Prefiera cupo limitado y selección previa para formar un grupo compatible.",
    ],
  },
  different: {
    title: "Qué hace AsiViajo diferente",
    items: [
      {
        title: "Una edición anual de cupo limitado",
        text: "No es un programa masivo. El tamaño del grupo es parte del estándar.",
      },
      {
        title: "Selección previa por compatibilidad",
        text: "Buscamos formar un grupo que se lleve bien, se respete y se adapte a un ritmo ordenado.",
      },
      {
        title: "Experiencias culturales con propósito",
        text: "Ciudades y momentos pensados para que no sea solo pasar y tomar fotos, sino observar, entender y recordar.",
      },
      {
        title: "Autonomía guiada",
        text: "Responsabilidad gradual: puntualidad, convivencia, manejo del tiempo y decisiones pequeñas acompañadas.",
      },
      {
        title: "Estándares AsiViajo de convivencia y presencia",
        text: "Cuidamos el ambiente del grupo: respeto, lenguaje, comportamiento en público y presencia en redes.",
      },
      {
        title: "Un cierre simbólico",
        text: "Un momento final que consolida lo vivido: un antes y después real, no solo una despedida.",
      },
    ],
  },
  outcomes: {
    title: "Lo que se llevan",
    intro: "Al regresar, muchas participantes fortalecen:",
    bullets: [
      "Confianza para expresarse y convivir.",
      "Responsabilidad personal (tiempo, hábitos, decisiones).",
      "Sensibilidad cultural (mirar el mundo con más criterio).",
      "Recuerdos profundos, no solo fotografías.",
    ],
    note: "La experiencia se vive; no se presenta como un curso.",
  },
  safety: {
    title: "Seguridad y acompañamiento",
    text: "Sabemos que para los padres la tranquilidad no es negociable. Por eso trabajamos con protocolos claros de movilidad, horarios, comunicación y convivencia, con coordinación permanente del equipo.",
  },
  process: {
    title: "Cómo funciona",
    steps: [
      "Preinscripción (10-12 minutos)",
      "Llamada breve con padres (15 min)",
      "Confirmación + reserva de cupo",
      "Preparación previa + Kit AsiViajo",
    ],
    cta: "Solicitar Preinscripción",
  },
  finalCta: {
    title: "Si buscas un tour más, AsiViajo no es eso.",
    text: "Si buscas una experiencia en Europa que marque una etapa, con un grupo compatible y un estándar alto de organización y convivencia, AsiViajo puede ser la decisión correcta.",
    primaryCta: "Solicitar Preinscripción",
    secondaryCta: "Recibir Presentación para Padres",
  },
};

export const COMPANY_INFO = {
  name: "AsiViajo",
  subbrand: "En mis 15",
  email: "Bedifferent@asiviajo.com",
  phone: "+507 6613-4200 / +507 393-2900",
  address: "Panamá",
};

export const IMAGES = {
  logo: asset("logo_av_15.png"),
  heroVideo: asset(
    "6745ef945573f426f7cfc217_Fontana%20Di%20Trevi%20Video%201920x1080.mp4",
  ),
  section: asset("new_15s.jpeg"),
  ogImage: asset("og-placeholder.svg"),
  gallery: [
    asset("carr1_15.jpg"),
    asset("carr2_15.jpg"),
    asset("carr3_15.jpg"),
    asset("carr4_15.jpeg"),
    asset("carr5_15.jpg"),
  ],
};
